export const AccountCurrentTypes = {
    SHOW_CURRENT: "SHOW_CURRENT",
    ADD_CURRENT: "ADD_CURRENT",
    UPDATE_CURRENT: "UPDATE_CURRENT",
    DELETE_CURRENT: "DELETE_CURRENT",
};
  